<template>
    <nav v-if="navigation.length" class="fixed-navigation">
        <sdk-docs-navi-section v-for="(navi, index) in navigation" :navi="navi" :key="index" />
    </nav>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
import SdkDocsNaviSection from './NaviSection'

const clientTopOffset = 250
const scrollEvent = 'scroll'

export default {
  name: 'SdkDocsNavigation',
  components: {
    SdkDocsNaviSection
  },
  computed: {
    ...mapState({
      navigation: state => state.sdk.currentNavigation
    })
  },
  methods: {
    ...mapMutations([
      'setSdkCurrentSection'
    ]),
    setSection () {
      const sections = document.querySelectorAll('[data-scroll]')
      let activeSection
      sections.forEach(section => {
        const elementTopPosition = section.getBoundingClientRect()['y'] || section.getBoundingClientRect()['top']
        if (elementTopPosition < clientTopOffset) {
          activeSection = section.getAttribute('data-scroll')
        }
      })
      if (activeSection) {
        this.setSdkCurrentSection(activeSection)
      }
    }
  },
  created () {
    window.addEventListener(scrollEvent, this.setSection)
  },
  destroyed () {
    window.removeEventListener(scrollEvent, this.setSection)
  }
}
</script>

<style src="../../../assets/scss/FixedNavigation.scss" lang="scss"></style>
